<template>
<div class="z-main">
<!-- <header class="z-title-header dark-color" style="border-bottom: 1px solid #F8F8F8;">

</header> -->
<div class="z-header">
	<div><router-link to="/login"><img src="../../assets/sysbars/left.png" /></router-link></div>
	<div>{{sitename+' - '}}{{$t('注册')}}</div>
	<div></div>
</div>
<div class="z-body">
	<div class="z-body-in">


<div class="z-form-item item-bg" >
	<div class="z-form-label" style="color: #000000;">
		{{$t('推荐人')}} ID
	</div>
	<div class="z-input-block">
		<input type="number" v-model="invitat_code"  :placeholder="$t('推荐人')+'ID'">
	</div>
</div>

<div class="z-form-item item-bg">
	<div class="z-form-label">
		<img class="z-form-icon" src="../../assets/icon/register/name.png">
	</div>
	<div class="z-input-block ">
		<input autocomplete="new-password" v-model="registerName"  :placeholder="$t('昵称')">
	</div>
</div>



<!-- <div class="z-form-item item-bg">
	<div class="z-form-label">
		<img class="z-form-icon" src="../../assets/icon/register/mobile.png">
	</div>
	<div class="z-input-block">
		<input autocomplete="new-password" v-model="phoneNumber" :placeholder="$t('请输入')+$t('手机号')">
	</div>
</div> -->

<div class="z-form-item item-bg">
	<div class="z-form-label">
		<img class="z-form-icon" src="../../assets/icon/register/email.png">
	</div>
	<div class="z-input-block">
		<input autocomplete="new-password" v-model="email" :placeholder="$t('请输入')+$t('邮箱')">
	</div>
</div>


<div class="z-form-item item-bg" >
	<div class="z-form-label">
		<img class="z-form-icon" src="../../assets/icon/register/password.png">
	</div>
	<div class="z-input-block ">
		<input autocomplete="new-password" type="password" v-model="passWord1" :placeholder="$t('设置登录密码')">
	</div>
</div>

<div class="z-form-item item-bg">
	<div class="z-form-label">
		<img class="z-form-icon" src="../../assets/icon/register/password.png">
	</div>
	<div class="z-input-block">
		<input autocomplete="new-password" type="password" v-model="passWord2" :placeholder="$t('确认登录密码')">
	</div>
</div>

<div class="z-form-item" style="background:none;">
	<div class="z-form-label">
		<v-checkbox dark color="#000000" v-model="left" label="" hide-details></v-checkbox>
	</div>
	<div class="z-input-block" style="color: #fff;">
		{{$t('已阅读并同意')}}<router-link :to="{name:'agreement',params:$route.params}">《{{$t('风险提示')}}》</router-link>
	</div>
</div>

<div class="z-form-item" style="background:none;padding:10px 0px;margin:10px 0px;">
	<div @click="register" class="common-btn">{{$t('立即开户')}}</div></div>
</div>
</div>
</div>
</div>
</template>

<script>
export default {
	name: 'register',
	data() {
		return {
			sitename:'XT blockchain',
			pid:'',//邀请人ID
			left: true,//协议勾选
			shareName:"",
			registerName:"",//账户代号
			phoneNumber:"",//手机号码
			passWord1:"",//密码
			passWord2:"",//密码
			code:"",//验证码
			userName:"",//昵称
			email:"",
			sendOnOff:false,
			invitat_code:"",
			countDown:60,
			timeOut:null,
			//协议
			checkbox: false,
		}
	},
	created(){
		this.getShare()
	},
	mounted() {

	},
	destroyed(){
	    let _this = this
	    clearTimeout(_this.timeOut)
	},
	methods: {
		//获取推荐人
		getShare(){
			if (this.$route.params.pid!=0) {
				this.invitat_code = this.$route.params.pid;
				this.post('api/index/referee.html', {
					uid: this.invitat_code
				}).then((res) => {
					if (res.code==0) {
						this.shareName=res.data.nickname
						this.sitename = res.data.sitename
					}
				})
			}

		},
		//发送邮箱验证码
		sendEmailCode:function () {
			let _this=this;
			this.post('api/index/sendEmailCode.html', {
				email: this.email
			}).then((res) => {

				if(res.code==0){
				_this.sendOnOff=true
				let timer = setInterval(function () {
				if(_this.countDown==0){
				clearInterval( timer )
				_this.sendOnOff=false
				_this.countDown=60
				}else {
				_this.countDown=_this.countDown-1
				}
				},1000)
				}
				this.$store.commit('layer',res.msg)
			})
		},
		//发送短信验证码
		sendSmsCode:function () {
			let _this=this;
			this.post('api/Sms/Send.html', {
				mobile: this.phoneNumber,
				cateid:1
			}).then((res) => {

				if(res.code==0){
				_this.sendOnOff=true
				let timer = setInterval(function () {
				if(_this.countDown==0){
				clearInterval( timer )
				_this.sendOnOff=false
				_this.countDown=60
				}else {
				_this.countDown=_this.countDown-1
				}
				},1000)
				}
				this.$store.commit('layer',res.msg)
			})
		},
		//注册提交
		register:function () {
			var _this = this;
			if(this.email=="" || this.passWord1=="" || this.passWord2=="" || this.invitat_code==""){
				this.$store.commit('layer',this.$t('部分信息未填写'))
			}
			else if(this.passWord1 != this.passWord2){
				this.$store.commit('layer',this.$t('两组密码不相同'))
			}
			else if(this.left==false){
				this.$store.commit('layer',this.$t('请同意交易协议'))
			}
			else {
				this.post('api/index/Register.html', {
					email: this.email,
					mobile: this.phoneNumber,
					newpwd: this.passWord2,
					realname:this.userName,//用户昵称
					pid:this.invitat_code,
					name:this.registerName,//账户代号
				}).then((res) => {
					this.$store.commit('layer',res.msg)
					if(res.code==0){
						_this.removeToken()
						_this.removeUid()
						_this.jump('/')
					}
				})
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .theme--dark.v-icon {
    color:#000000!important;
  }
  .item-bg{
    background: #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/register.vue